import { BDSColor } from '../tokens/color';
import { hexToRgba } from '../utils';

export const color = {
  static: {
    white: {
      role: '',
      light: BDSColor.common.white,
      dark: BDSColor.common.white,
    },
    black: {
      role: '',
      light: BDSColor.common.black,
      dark: BDSColor.common.black,
    },
    primary: {
      role: '',
      light: BDSColor.aquamarine[50],
      dark: BDSColor.aquamarine[50],
    },
    secondary: {
      role: '',
      light: BDSColor.purple[50],
      dark: BDSColor.purple[50],
    },
    warning: {
      role: '',
      light: BDSColor.pink[50],
      dark: BDSColor.pink[50],
    },
    red: {
      role: '',
      light: BDSColor.red[50],
      dark: BDSColor.red[50],
    },
    pink: {
      role: '',
      light: BDSColor.pink[50],
      dark: BDSColor.pink[50],
    },
    adult: {
      role: '',
      light: BDSColor.red[50],
      dark: BDSColor.red[50],
    },
  },
  text: {
    default: {
      role: '기본 텍스트 색상',
      light: BDSColor.common.black,
      dark: BDSColor.common.white,
    },
    TXT_0: {
      role: '중요도가 낮은 텍스트 색상',
      sub_description: 'Input Field의 가이드 텍스트 컬러',
      light: BDSColor.neutral[30],
      dark: BDSColor.neutral[50],
    },
    TXT_1: {
      role: '텍스트가 밀집된 영역에서 중요도가 낮은 텍스트의 컬러',
      sub_description: 'Info text, sub text',
      light: BDSColor.neutral[40],
      dark: BDSColor.neutral[40],
    },
    TXT_2: {
      role: '본문 텍스트에 사용되는 색상',
      sub_description: '본문',
      light: BDSColor.neutral[45],
      dark: BDSColor.neutral[30],
    },
    TXT_3: {
      role: '본문보다 상위 레벨의 텍스트에 사용되는 색상',
      sub_description: '메뉴 타이틀 등',
      light: BDSColor.neutral[55],
      dark: BDSColor.neutral[25],
    },
    TXT_4: {
      role: '페이지에서 상위 레벨의 중요도를 갖는 텍스트에 사용되는 색상',
      sub_description: '타이틀',
      light: BDSColor.neutral[70],
      dark: BDSColor.common.white,
    },
    disable: {
      role: '중요도 최하 텍스트에 사용되는 색상',
      sub_description: '거의 사용되지 않음',
      light: hexToRgba(BDSColor.neutral[70], 0.6),
      dark: hexToRgba(BDSColor.common.white, 0.6),
      // light: 'rgba(19, 20, 21, 0.6)',
      // dark: 'rgba(255, 255, 255, 0.6)',
    },
    info: {
      role: 'Info',
      sub_description: 'AI 모델 선택 모달 > 사용 중, 버블 표시 텍스트',
      light: '#229BDC',
      dark: '#229BDC',
    },
  },
  line: {
    line_1: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[70],
    },
    line_2: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[25],
      dark: BDSColor.cool[60],
    },
    line_3: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.neutral[20],
      dark: BDSColor.cool[55],
    },
    line_4: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.cool[10],
      dark: BDSColor.cool[50],
    },
    line_5: {
      role: 'Text',
      sub_description: 'Text',
      light: hexToRgba(BDSColor.common.black, 0.2),
      dark: hexToRgba(BDSColor.common.white, 0.2),
    },
    line_6: {
      role: '프로필 라인 색상',
      sub_description: '유저 프로필',
      light: hexToRgba(BDSColor.neutral[20], 0.8),
      dark: hexToRgba(BDSColor.cool[55], 0.8),
    },
  },
  icon: {
    icon_1: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[35],
      dark: BDSColor.cool[60],
    },
    icon_2: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.cool[60],
      dark: BDSColor.neutral[15],
    },
    icon_3: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[40],
      dark: BDSColor.cool[55],
    },
    icon_4: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.common.black,
      dark: BDSColor.common.white,
    },
    icon_5: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[15],
      dark: BDSColor.cool[65],
    },
    icon_6: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.variant[60],
      dark: BDSColor.neutral[40],
    },
    icon_7: {
      role: 'Text',
      sub_description: 'Text',
      light: BDSColor.neutral[40],
      dark: BDSColor.variant[20],
    },
    bookmark: {
      role: '포인트 컬러',
      light: BDSColor.cool[10],
      dark: '#000', // 미정
    },
  },
};
